import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageHeaderComponent } from './page-header/page-header.component';
import { AnimationComponentComponent } from './animation-component/animation-component.component';
import { FooterComponent } from './footer/footer.component';
import { ConfirmationPopoverModule } from 'angular-confirmation-popover';
import { LanguageTranslationModule } from '../modules/language-translation/language-translation.module';
import { ModalEditComponent } from './modal-edit/modal-edit.component';
import { InputRadioComponent } from './input-radio/input-radio.component';
import { Ng2ImgMaxModule } from 'ng2-img-max';


@NgModule({
	imports: [
		CommonModule,
		LanguageTranslationModule,
		ConfirmationPopoverModule.forRoot({
			confirmButtonType: 'danger'
		}),
		Ng2ImgMaxModule
	],
	declarations: [
		PageHeaderComponent,
		AnimationComponentComponent,
		FooterComponent,
		ModalEditComponent,
		InputRadioComponent,
	],
	exports: [
		PageHeaderComponent,
		AnimationComponentComponent,
		FooterComponent,
		ModalEditComponent,
		InputRadioComponent
	]
})
export class SharedComponentModule { }
